import bridge from '../../bridge/bridge';
import { Context } from '../sdk/types';
import {
  LogContextRequest,
  LogInpPerformanceRequest,
  LogLcpPerformanceRequest,
  LogNetworkPerformanceRequest,
  LogTtfbPerformanceRequest,
  LogUncaughtErrorRequest,
  LogUnhandledRejectionRequest,
} from './actions';
import {
  InpPerformanceReport,
  LcpPerformanceReport,
  LogApi,
  NetworkPerformanceReport,
  TtfbPerformanceReport,
} from './types';

/**
 * Logs uncaught error.
 *
 * @param error Uncaught error to log.
 */
function logUncaughtError(error: string) {
  tryLogAndIgnoreFailure(async () => {
    await bridge.app.postMessage(new LogUncaughtErrorRequest(error));
  });
}

/**
 * Logs unhandled rejection.
 *
 * @param error Unhandled rejection to log.
 */
function logUnhandledRejection(rejection: string) {
  tryLogAndIgnoreFailure(async () => {
    await bridge.app.postMessage(new LogUnhandledRejectionRequest(rejection));
  });
}

function logLcpPerformance(lcpPerformanceReport: LcpPerformanceReport) {
  tryLogAndIgnoreFailure(async () => {
    await bridge.app.postMessage(
      new LogLcpPerformanceRequest(lcpPerformanceReport)
    );
  });
}

function logTtfbPerformance(ttfbPerformanceReport: TtfbPerformanceReport) {
  tryLogAndIgnoreFailure(async () => {
    await bridge.app.postMessage(
      new LogTtfbPerformanceRequest(ttfbPerformanceReport)
    );
  });
}

function logInpPerformance(inpPerformanceReport: InpPerformanceReport) {
  tryLogAndIgnoreFailure(async () => {
    await bridge.app.postMessage(
      new LogInpPerformanceRequest(inpPerformanceReport)
    );
  });
}

function logNetworkPerformance(
  networkPerformanceReport: NetworkPerformanceReport
) {
  tryLogAndIgnoreFailure(async () => {
    await bridge.app.postMessage(
      new LogNetworkPerformanceRequest(networkPerformanceReport)
    );
  });
}

/**
 * Logs context.
 *
 * @param context Context to log.
 */
function logContext(context: Context) {
  tryLogAndIgnoreFailure(async () => {
    await bridge.app.postMessage(new LogContextRequest(context));
  });
}

/** Tries to log. If fails to log, ignores failure. */
async function tryLogAndIgnoreFailure(
  logFunc: () => Promise<void>
): Promise<void> {
  try {
    await logFunc();
  } catch {
    // Intentionally ignore any logging failures.
  }
}

const log: LogApi = {
  logUncaughtError,
  logUnhandledRejection,
  logLcpPerformance,
  logTtfbPerformance,
  logInpPerformance,
  logNetworkPerformance,
  logContext,
};

export { log };
